(function () {
  'use strict';

  function playChime() {
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      var ctx = new Ctx();
      [[523.25, 0], [659.25, 0.13], [783.99, 0.26]].forEach(function(pair) {
        var freq = pair[0], t = pair[1];
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.value = freq;
        var start = ctx.currentTime + t;
        gain.gain.setValueAtTime(0.001, start);
        gain.gain.linearRampToValueAtTime(0.25, start + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.001, start + 0.45);
        osc.start(start);
        osc.stop(start + 0.45);
      });
    } catch (_) {}
  }

  function bounceCartIcon() {
    var cartEl =
      document.querySelector('cart-icon') ||
      document.querySelector('.cart-icon') ||
      document.querySelector('[data-testid="header-cart-icon-bubble"]') ||
      document.querySelector('.header__cart');
    if (!cartEl) return;
    cartEl.classList.remove('retro-cart-bounce');
    void cartEl.offsetWidth;
    cartEl.classList.add('retro-cart-bounce');
    cartEl.addEventListener('animationend', function() {
      cartEl.classList.remove('retro-cart-bounce');
    }, { once: true });
  }

  function spawnParticles(button) {
    var r = button.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    var colours = ['#06d6a0', '#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b'];
    for (var i = 0; i < 10; i++) {
      (function(idx) {
        var p = document.createElement('span');
        p.className = 'retro-particle';
        var size = 6 + Math.random() * 6;
        var colour = colours[idx % colours.length];
        p.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + cx + 'px;top:' + cy + 'px;background:' + colour + ';box-shadow:0 0 8px ' + colour;
        document.body.appendChild(p);
        var angle = (idx / 10) * Math.PI * 2;
        var dist = 60 + Math.random() * 60;
        var dx = Math.cos(angle) * dist;
        var dy = Math.sin(angle) * dist;
        p.animate(
          [
            { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
            { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) scale(0)', opacity: 0 }
          ],
          { duration: 500 + Math.random() * 200, easing: 'cubic-bezier(0,0,0.2,1)', fill: 'forwards' }
        ).onfinish = function() { p.remove(); };
      })(i);
    }
  }

  function flashButton(btn) {
    btn.classList.remove('retro-btn-success');
    void btn.offsetWidth;
    btn.classList.add('retro-btn-success');
    btn.addEventListener('animationend', function() {
      btn.classList.remove('retro-btn-success');
    }, { once: true });
  }

  document.addEventListener('click', function(e) {
    var btn =
      e.target.closest('.add-to-cart-button') ||
      e.target.closest('[data-testid="add-to-cart-button"]') ||
      e.target.closest('.product-form__submit') ||
      e.target.closest('[name="add"]');
    if (!btn) return;
    playChime();
    spawnParticles(btn);
    flashButton(btn);
    setTimeout(bounceCartIcon, 380);
  }, true);

})();
